import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	rootContainer: {
		padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
		backgroundColor: theme.palette.background.default,
		[theme.breakpoints.up('md')]: {
			padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`
		}
	},
	contactIcon: {
		marginTop: 3.5,
		marginRight: theme.spacing(1),
		color: theme.palette.primary.main
	},
	contact: {
		marginRight: theme.spacing(1)
	},
	emailLink: {
		marginRight: theme.spacing(2)
	}
}));
